// extracted by mini-css-extract-plugin
export default {"item":"InputItem_item__wCQ29","tag":"InputItem_tag__gtRQH","required":"InputItem_required__xjiQn","input":"InputItem_input__mPKS8"};